import React, { useState, useEffect } from "react";
import SearchSvgBlog from "app/Icons/SearchSvgBlog";
import { TextInputBase, DropdownBrowser } from "@reusejs/react";
import { useRouter } from "next/router";
import { getAllArticlesBySearch } from "../../../services/blogs/index";

const BlogSearchComponent = (props: any) => {
  const [searchValue, setSearchValue] = useState<any>("");
  const [searchedArticles, setSearchedArticles] = useState<any>([]);
  const [noMatchComponent, setNoMatchComponent] = useState<any>("");
  const router = useRouter();

  const getArticleBySearch = async (query: any) => {
    setSearchValue(query);
    let filteredArticles: any;
    if (query !== "") {
      let allPostBySearch: any = await getAllArticlesBySearch(query);
      filteredArticles = allPostBySearch.data.map((item: any) => {
        return {
          label: item.attributes.title,
          value: item.attributes.slug,
        };
      });
      if (allPostBySearch.data.length == 0) {
        setNoMatchComponent(
          <div className="w-full rounded-md border text-md font-medium max-h-40 relative -top-6 px-4 py-2">
            No search results found
          </div>
        );
      } else {
        setNoMatchComponent("");
      }
    }
    setSearchedArticles(filteredArticles);
  };

  useEffect(() => {
    if (searchValue == "") {
      setSearchedArticles([]);
    }
  }, [searchValue]);
  return (
    <>
      <div className="relative sm:w-full">
        <TextInputBase
          name={"email"}
          onChange={(value) => {
            getArticleBySearch(value);
            setSearchValue(value);
          }}
          placeholder={"Search"}
          type="text"
          value={searchValue}
          htmlFor="email"
          textInputBaseClasses={{
            wrapper: "w-full mb-6 flex-m-auto",
            padding: "pl-8",
            formInput: "pl-8",
            font: "w-full",
          }}
          textInputPrefix={
            <div className="pointer-events-none inset-y-0 left-0 flex items-center absolute left-2">
              <SearchSvgBlog />
            </div>
          }
          textInputSuffix={""}
        />
      </div>
      {searchedArticles?.length > 0 && (
        <DropdownBrowser
          dropdownBrowserClasses={{
            containerClasses:
              "border w-full max-h-40 overflow-y-auto z-10 absolute -top-6 dark:border-gray-800 bg-white dark:bg-slate-900 focus:outline-none rounded-md",
          }}
          items={searchedArticles}
          onClick={(item) => {
            router.replace(`/blogs/${item.value}`);
            setSearchedArticles([]);
            setSearchValue("");
          }}
        />
      )}
      {searchValue !== "" && noMatchComponent}
    </>
  );
};

export default BlogSearchComponent;
